import React from 'react';

function PrevPlay () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#clip0_202_4670)">
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M.714.714v18.572"
        />
        <path
          fill="#fff"
          d="M19.286 16.656a1.429 1.429 0 01-.743 1.257 1.428 1.428 0 01-1.429 0L6.843 11.2a1.428 1.428 0 010-2.4l10.3-6.657a1.429 1.429 0 011.428 0 1.43 1.43 0 01.743 1.257l-.028 13.257z"
        />
      </g>
      <defs>
        <clipPath id="clip0_202_4670">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PrevPlay;
